// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__-shIl","actionsCol":"EnrolledClinics_actionsCol__PGKXO"};